import { boolean, object, constraints, string } from "./helpers";
import { SoftwareUpdate } from "./types";

export const software_update = object<SoftwareUpdate>({
  policy: object({
    use_latest: object({
      value: boolean("AUTO_UPDATE_LATEST"),
      constraints: constraints()
    }),
    version: object({
      value: string("SELECT_VERSION"),
      constraints: constraints()
    })
  })
}).required();
